// necessary dependencies //
import { React } from "react";
import { Link } from "react-router-dom";
import Fade from "react-reveal/Fade";
// css //
import styles from "./Hero.module.scss";
// image, icons //
import { Line } from "../../images/icons/Line";
import { Ellipse2 } from "../../images/icons/Ellipse2";
import { Ellipse3 } from "../../images/icons/Ellipse3";
import { Ellipse4 } from "../../images/icons/Ellipse4";
import { Rectangle } from "../../images/pictures/Rectangle";
import { RectangleYellow } from "../../images/pictures/RectangleYellow";
import me from "../../images/pictures/me_icon.png";
import shonic from "../../images/pictures/shonic.png";
import shonic2 from "../../images/pictures/shonic3.png";
import shonic3 from "../../images/pictures/shonic4.png";
import ardawalika from "../../images/pictures/ardawalika2.png";
import ardawalika2 from "../../images/pictures/ardawalika3.png";
import ardawalika3 from "../../images/pictures/ardawalika4.png";

const Hero = () => {
  return (
    <>
      <div className={styles.hero_container}>
        {/* <p>hello</p> */}
        {/* <Miscellaneous/> */}
        <Fade bottom cascade>
          <div className={`${styles.hero_body} container`}>
            <Line />
            <h2>code with</h2>
            <h1>FIRA</h1>
            <Line />
          </div>
        </Fade>
        {/* <Fade top cascade> */}
        <div className={`${styles.hero_about_me} container`} id={"aboutme"}>
          <Fade bottom>
            <h2>about me</h2>
          </Fade>
          <div className={styles.hero_container_main_details}>
            <div className={styles.main_details_text}>
              <h1>
                Hello, <br />
                I'm Fira.
              </h1>
              <p>
                Welcome to my personal website! <br />
                I'm a programmer and enjoy building software apps that can help
                me strengthen not only my creativity but also my skills in
                software engineering!
                <br />
                <span>
                  <a
                    href="https://drive.google.com/file/d/1E02ce_jepUsGj9bWDbO1gomne8mC26MO/view?usp=sharing"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Check out my resume!{" "}
                  </a>{" "}
                </span>
              </p>
            </div>
            <div className={styles.main_details_image}>
              {/* <div style={{backgroundImage: `url(${me})`, height: '85vh', backgroundRepeat: 'no-repeat'}}>
              
              </div> */}
              <img src={me} alt="me" />
            </div>
          </div>
          <Line />
        </div>
        {/* </Fade> */}
        <div className={`${styles.hero_works} container`} id={"works"}>
          <Fade bottom>
            <h2>works</h2>
          </Fade>
          <Ellipse2 className={styles.ellipse2} />
          {/* <Rectangle/> */}
          {/* <div className={styles.card_container} style={{ backgroundImage: `url(${me})`, backgroundRepeat: `no-repeat`, backgroundSize: `cover`, backgroundPosition: `center`, height: `100vh`}}>

          </div> */}
          {/* <div className={styles.work_detail}>
              <div className={styles.card_container} style={{ backgroundImage: `url(${rectangle})`, backgroundRepeat: `no-repeat`, backgroundSize: `cover`, backgroundPosition: `center`}}>

              </div>                 
          </div> */}
          <div className={styles.work_detail}>
            <Rectangle />
            <div className={styles.work_images}>
              {/* <p className={styles.testes}>tes</p> */}
              <Link to={`/shonic`}>
                <img src={shonic} className={styles.work_image} />
                <img src={shonic2} className={styles.work_image} />
                <img src={shonic3} className={styles.work_image} />
              </Link>
            </div>
            <Fade bottom cascade>
              <div className={styles.work_name}>
                {/* <Link to={`/shonic`}> */}
                <a className={styles.title} href="/shonic">
                  Shonic
                </a>
                {/* </Link> */}
                <div className={styles.links}>
                  {/* <a href="https://shonicteam.vercel.app/">LIVE</a> */}
                  <a href="https://drive.google.com/file/d/1FhpFnKCrz9KZAwt16RERs1EfLFRboDu5/view">
                    DEMO
                  </a>
                  <a href="https://gitlab.com/shonic/shonic-website">REPO</a>
                </div>
                <p>
                  * Due to deprecated heroku's free tier,{" "}
                  <a
                    href="https://shonicteam.vercel.app/"
                    className={styles.link}
                  >
                    Shonic
                  </a>
                  's live site is currently under maintenance.
                </p>
              </div>
            </Fade>
          </div>
          {/* <Line/>           */}
          <Ellipse3 className={styles.ellipse2} />
          <div className={styles.work_detail}>
            <RectangleYellow />
            <div className={styles.work_images}>
              {/* <p className={styles.testes}>tes</p> */}
              <Link to={`/ardawalika`}>
                <img src={ardawalika} className={styles.work_image} />
                <img src={ardawalika2} className={styles.work_image} />
                <img src={ardawalika3} className={styles.work_image} />
              </Link>
            </div>
            <Fade bottom cascade>
              <div className={styles.work_name}>
                <Link to={`/ardawalika`}>
                  <a className={styles.title}>Ardawalika</a>
                </Link>
                <div className={styles.links}>
                  {/* <a href="https://still-castle-48435.herokuapp.com/">LIVE</a> */}
                  <a href="https://drive.google.com/file/d/1E0Cf-uulL8h2nf6htuUiY9_6MH6a-XOh/view?usp=sharing">
                    DEMO
                  </a>
                  <a href="https://gitlab.com/ajisetiaji101/ardawalika">REPO</a>
                </div>
                <p>
                  * Due to deprecated heroku's free tier,{" "}
                  <a
                    href="https://still-castle-48435.herokuapp.com/"
                    className={styles.link}
                  >
                    Ardawalika
                  </a>
                  's live site is currently under maintenance.
                </p>
              </div>
            </Fade>
          </div>
          <Ellipse4 className={styles.ellipse4} />
        </div>
        <div className={`${styles.get_in_touch} container`}>
          <Line />
          <Fade bottom cascade>
            <div id={"contact"}>
              <h1>
                Get In
                <br /> Touch <br /> With <br /> Me <br />
              </h1>
            </div>
          </Fade>
          <Fade bottom cascade>
            <div className={styles.get_in_touch_img_details}>
              <Fade bottom>
                <div className={styles.get_in_touch_img}>
                  <img src={me} />
                  <buttton>
                    <a href="https://www.linkedin.com/in/firdha-isly-ramadhani-053a75159/">
                      check <br />
                      out my <br />
                      linkedin!
                    </a>
                  </buttton>
                  {/* <buttton><a href="https://www.linkedin.com/in/firdha-isly-ramadhani-053a75159/">check <br />out my <br />linkedin!</a></buttton> */}
                </div>
              </Fade>
              <Fade bottom cascade>
                <div className={styles.socials}>
                  <ul>
                    <li>
                      <a href="https://github.com/firdhair">GitHub</a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/in/firdha-isly-ramadhani-053a75159/">
                        LinkedIn
                      </a>
                    </li>
                    <li>
                      <a href="https://gitlab.com/firdhair">GitLab</a>
                    </li>
                    <li>firdhair30@gmail.com</li>
                  </ul>
                </div>
              </Fade>
            </div>
          </Fade>
        </div>
      </div>
    </>
  );
};

export default Hero;
